@let aptitude = item();

<div class="flex h-screen flex-col overflow-y-hidden">
  <div class="p-md flex flex-col">
    <span class="text-content-secondary">{{ phase()?.nom }}</span>
    <span class="title-small-semibold">{{ aptitude.nom }}</span>
  </div>

  <hlm-tabs class="min-h-0 w-full" tab="productions">
    <hlm-tabs-list class="px-md">
      <button hlmTabsTrigger="productions">Productions ({{ productions().length }})</button>
      <button hlmTabsTrigger="indices">Indices de résultats ({{ indicesResultats().length }})</button>
    </hlm-tabs-list>
    <div hlmTabsSeparator></div>
    <div class="p-lg h-full overflow-y-auto">
      <div hlmTabsContent="productions">
        @if (peutModifier()) {
          <button (click)="createProduction()" hlmBtn variant="secondary">
            <ng-icon name="lucidePlus" />
            Ajouter une production
          </button>
        }

        <div class="mt-lg gap-md flex flex-col">
          @for (item of productions() | trierPar: 'nom'; track item.id) {
            <div class="group/item py-xxs h-[48px]" cardItem>
              <span cardItemTitle>{{ item.nom }}</span>
              @if (peutModifier()) {
                <div class="invisible group-hover/item:visible" cardItemActions>
                  <button
                    [hlmDropdownMenuTrigger]="actionsMenu"
                    [hlmDropdownMenuTriggerData]="{ $implicit: { item: item, actions: actionsProduction } }"
                    hlmBtn
                    variant="ghost"
                  >
                    <ng-icon name="lucideEllipsisVertical" />
                  </button>
                </div>
              }
            </div>
          } @empty {
            <span class="text-content-secondary paragraph-medium-medium"
              >Aucune production n'a été créée dans l'aptitude.</span
            >
          }
        </div>
      </div>
      <div hlmTabsContent="indices">
        @if (peutModifier()) {
          <button (click)="createIndice()" hlmBtn variant="secondary">
            <ng-icon name="lucidePlus" />
            Ajouter un indice de résultats
          </button>
        }
        <div
          class="mt-lg gap-md flex flex-col"
          [cdkDropListData]="indicesResultats() | trierPar: 'indice'"
          (cdkDropListDropped)="dropIndiceResultat($event)"
          gap="16px"
          cdkDropList
          cdkDropListGroup
        >
          @for (item of indicesResultats() | trierPar: 'indice'; track item.id) {
            <app-item-indice-resultats
              [indiceResultats]="item"
              [phases]="phases()"
              [referentiel]="referentiel()"
              [peutModifier]="peutModifier()"
              [aptitude]="aptitude"
            />
          } @empty {
            <span class="text-content-secondary paragraph-medium-medium"
              >Aucun indice de résultats n'a été créé dans l'aptitude.</span
            >
          }
        </div>
      </div>
    </div>
  </hlm-tabs>
</div>

<ng-template #actionsMenu let-ctx>
  <hlm-dropdown-menu>
    @for (action of ctx.actions; track $index) {
      <button (triggered)="action.action(ctx.item)" hlmDropdownMenuItem>
        <ng-icon [name]="action.icon" hlmMenuIcon />
        {{ action.label }}
      </button>
    }
  </hlm-dropdown-menu>
</ng-template>
